import React from 'react';

export const BoldText = ({ searchTerm, string = '' }) => {
  if (!searchTerm) {
    return <span>{string}</span>;
  }
  // Split the string on the search term
  const escapeRegExp = (str) => {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
  };
  const notBold = string.split(new RegExp(escapeRegExp(`${searchTerm}`), 'i'));

  // Get a list of all the indexes where the search term starts
  const getBoldIndexes = (string, indexes = []) => {
    const lastIndex = indexes[indexes.length - 1] + 1 || 0;
    const index = string
      .toLowerCase()
      .indexOf(searchTerm.toLowerCase(), lastIndex);
    if (index === -1) {
      return indexes;
    }
    return getBoldIndexes(string, indexes.concat(index));
  };
  const boldIndexes = getBoldIndexes(string);

  // Map over the unboldened strings adding them to a span and then adding in the bold search term after them
  const boldened = notBold.map((chunk, index) => {
    // If this is the last not bold string we can just return it
    if (index === notBold.length - 1) {
      return <span key={index}>{chunk}</span>;
    }

    // We are getting the substring from the passed in string so we can keep exact casing
    const boldString = string.substr(boldIndexes[index], searchTerm.length);
    return (
      <span key={index}>
        {chunk}
        <strong>{boldString}</strong>
      </span>
    );
  });
  return <span>{boldened}</span>;
};
